import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Restrict route access by per-company role.
 *
 * Props:
 *   allow: array of role strings (e.g. ['admin', 'user', 'venue_manager'])
 *   children: route component
 *
 * Reads the role from CompanyMember (state.company.list[].role) for the
 * active company. Superadmins always pass. If the role isn't in allow,
 * redirect to a safe page (venue_managers → /calendar, otherwise /).
 */
export default function RoleGuard({ allow, children }) {
  const { userInfo } = useSelector((state) => state.auth);
  const { activeCompanyId, list, hasFetched } = useSelector((state) => state.company);

  // Superadmin bypass — they can reach anything
  if (userInfo?.is_superadmin) return children;

  // Wait until companies are loaded so we can read the per-company role
  if (!hasFetched) return null;

  const activeCompany = list.find((c) => c.id === activeCompanyId);
  const role = activeCompany?.role;

  if (!role) return null;
  if (!allow.includes(role)) {
    const fallback = role === 'venue_manager' ? '/library' : '/';
    return <Navigate to={fallback} replace />;
  }
  return children;
}
